export const I18nPrefix = 'strava.subscriptions.checkout';

export const I18nPrefixOrganic = `${I18nPrefix}.summary.organic`;
export const I18nPrefixPromoButton = `${I18nPrefixOrganic}.promo_code.cta`;
export const I18nPrefixPromoCode = `${I18nPrefixOrganic}.promo_code`;
export const I18nPrefixTrial = `${I18nPrefix}.summary.trial`;
export const I18nPrefixHoliday = `${I18nPrefix}.summary.holiday`;
export const I18nPrefixStudent = `${I18nPrefix}.summary.students`;
export const I18nPrefixSubscriptionPreview =
  'components.subscription_preview.checkout';
export const I18nPrefixForm = `${I18nPrefix}.form`;
export const I18nPrefixTerms = `${I18nPrefix}.terms`;
